import { initConsoleLogger } from '@salsita-ai/platform-common/utils'

// TODO: this is used without datadog??? There are two loggers now in the codebase...
export const logger = initConsoleLogger()
